var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.049,
    cy: 11.334,
    r: 9.451,
    stroke: "#036D6D",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#036D6D",
    fillRule: "evenodd",
    d: "M11.049 6.368c-.579 0-1.048.469-1.048 1.047v2.872H7.13a1.048 1.048 0 1 0 0 2.095H10v2.871a1.048 1.048 0 1 0 2.096 0v-2.871h2.87a1.048 1.048 0 1 0 0-2.095h-2.87V7.415c0-.578-.47-1.047-1.048-1.047z",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;